// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__1LHlv","noInteraction":"EventWrapper_noInteraction__5axOC","pointerPassthrough":"EventWrapper_pointerPassthrough__11IGv"};